export const GET_TIME_CARDS = `
  mutation ($token: String!, $year: Int!, $month: Int) {
    getTimeCardsForUser(actualsSearch: {token: $token, year: $year, month: $month}) {
      data {
        id
        status
        week
        year
        month
        total
        elementMap {
          element1Id
          element2Id
          element3Id
          element4Id
        }
        isCurrent
        productOwners
        portfolioOwners
      }
      error {
        code
        message
        statusCode
      }
    }
  }
`
